import { useStatContext } from "@/contexts/stat-context";
import { useTimelineContext } from "@/contexts/timeline-context";
import { useLoggedIn } from "@/hooks";

import { useTimelineStream } from "./useTimelineStream";

function useUserStream() {
  const { isLoggedIn } = useLoggedIn();
  const statContext = useStatContext();
  const { timelineId } = useTimelineContext();

  return useTimelineStream(timelineId, "user", {
    statContext,
    enabled: isLoggedIn,
  });
}

export { useUserStream };
